import * as Sentry from '@sentry/react';

/**
 * Reports a persisted blocked queue record to Sentry for support diagnostics.
 * It carries identifiers and classification codes only; answers, headers,
 * captcha tokens, error messages and response bodies never leave the record.
 * Transient preparation failures stay pending and are not reported.
 */
export function reportQueueFailure(result) {
  const { failure } = result;

  if (result.status !== 'failed' || failure?.status !== 'blocked') return;

  Sentry.withScope((scope) => {
    scope.setLevel('warning');
    scope.setTags({
      feedback_queue_stage: failure.stage,
      feedback_queue_reason: failure.kind,
      feedback_queue_outcome: failure.outcome,
      feedback_queue_kind: result.kind,
    });
    scope.setContext('feedback_queue', {
      submission_id: result.submissionId,
      channel_id: result.nodeId,
      flow_id: result.flowId,
      http_status: failure.httpStatus,
      api_code: failure.apiCode,
      attempt_count: failure.attempts?.count ?? null,
      last_attempt_at: failure.attempts?.lastAt ?? null,
    });
    scope.setFingerprint(['feedback-queue', failure.stage, failure.kind, failure.outcome]);

    Sentry.captureMessage(
      failure.stage === 'post' ? 'Queued feedback POST did not succeed' : 'Queued feedback blocked before POST',
    );
  });
}
